/**
 * P0.3 — Garde des routes /admin/* côté React.
 *
 * Avant : les pages admin se chargeaient pour n'importe quel visiteur tapant
 * l'URL (la protection ne reposait que sur le backend, lui-même non protégé).
 * Désormais : pendant le chargement de la session on n'affiche rien, puis les
 * non-admins sont redirigés vers l'accueil.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const AdminGuard = ({ children }) => {
  const { isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminGuard;
